import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import QuillEditor from '../../../globalcomponents/QuillEditor';
import './sop-agent-notes.scss';
import { updateUserNotes } from '../../../Redux/util/Apis/users';
import { setGlobalError } from '../../../Redux/Reducer/GlobalError';
import { debounce } from '../inboxUtils';

const modules = {
  toolbar: {
    container: '#toolbar-11'
  },
  clipboard: {
    matchVisual: false
  }
};

const formats = [
  'bold',
  'italic',
  'underline',
  'list',
  'link',
  'bullet',
  'indent',
  'color'
];

const AgentNotes = ({ userNotes, updateNotesHandler, darkMode }) => {
  const dispatch = useDispatch();
  const [editorText, setEditorText] = useState(userNotes);

  const handleChange = html => {
    setEditorText(html);
    debounce(async () => {
      const result = await updateUserNotes(html);
      if (result?.error) {
        dispatch(setGlobalError(result.message));
        return;
      }
      if (result.notes) {
        updateNotesHandler?.(result.notes);
      }
    }, 3000)();
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%'
      }}
    >
      <QuillEditor
        className={`custom-editor${darkMode ? '-dark' : ''}`}
        value={editorText}
        onChange={handleChange}
        formats={formats}
        modules={modules}
        theme="bubble"
        placeholder="Type here.."
      />
    </div>
  );
};

export default AgentNotes;
